import { useCallback } from 'react';

import type { ActionTemplate } from 'config/api/actionLibrary/actionLibrary.types';
import userDataStorage from 'storages/userDataStorage';

const useIsActionTemplateOwner = () => {
  // @ts-ignore
  const userData = userDataStorage.get() || {};
  const { id: userId } = userData;

  const isOwner = useCallback(
    (template: ActionTemplate) => {
      if (!template || !template.lockedByUser || !template.lockedByUser.id) return false;
      return template.lockedByUser.id === userId;
    },
    [userId],
  );

  return isOwner;
};

export default useIsActionTemplateOwner;
